const contentMessage = {
  dataNotFound: 'Data not found!'
};

export { contentMessage };
